import { fromJS } from 'immutable';
import { useCallback, useContext, useMemo } from 'react';
import memoizeOne from 'react-utils/memoizeOne';
import { createDimensionTableReportForDrilldown, createRelationalReportFromBaseReport } from 'reporting-snowflake/relational/utils/report-utils';
//@ts-expect-error untyped dependency
import { stageDisplayLabelFields } from 'reporting-snowflake/relational/enhance/drilldown/generate';
import { ReportWithOptions } from 'reporting-snowflake/relational/resolve/resolve-records';
import PlatformReportResolver from 'reporting-ui-components/components/PlatformReport/PlatformReportResolver';
//@ts-expect-error untyped dependency
import { createDefaultReportOptions } from 'reporting-ui-components/components/snowflake/report-options';
//@ts-expect-error untyped dependency
import { useDeps } from 'reporting-ui-components/components/snowflake/useDeps';
//@ts-expect-error untyped dependency
import { dataRequirementsAreEquivalent } from 'reporting-ui-components/components/snowflake/internal/queryUtils';
import { EnablementTrackingContext } from '../../../../monitoring/EnablementTrackingContext';
import { SRVDatasetTableActionsBar } from './SRVDatasetTableActionsBar';
import { getName, getReportDescription } from 'reporting-data/report/reportGetters';
import { SelectedReports } from 'reporting-action-components/reportingActions/exportReport/ExportReportButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useUnsummarizedTable = reportDefinition => {
  const {
    data: {
      meta
    } = {
      meta: undefined
    }
  } = useDeps(reportDefinition);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoizedCreateReportToResolve = useCallback(memoizeOne(report => report, dataRequirementsAreEquivalent), []);
  const memoizedReport = memoizedCreateReportToResolve(ReportWithOptions({
    reportDefinition,
    reportOptions: createDefaultReportOptions(reportDefinition)
  }));
  return useMemo(() => {
    if (!meta) {
      return undefined;
    }
    return createDimensionTableReportForDrilldown(stageDisplayLabelFields(meta, memoizedReport.reportDefinition), meta);
  }, [meta, memoizedReport]);
};
export const SRVDatasetTableSnowflakeReport = ({
  previewReport,
  suppressActionsBar = false
}) => {
  const relationalReport = createRelationalReportFromBaseReport(previewReport);
  const unsummarizedDefinition = useUnsummarizedTable(relationalReport);
  const {
    trackingApplicationName,
    trackingAssetType,
    trackingScreenName
  } = useContext(EnablementTrackingContext);
  const report = useMemo(() => {
    if (!unsummarizedDefinition) {
      return undefined;
    }
    return fromJS({
      name: getName(previewReport),
      description: getReportDescription(previewReport),
      reportDefinition: unsummarizedDefinition
    });
  }, [previewReport, unsummarizedDefinition]);
  if (!report) {
    return null;
  }
  const initialReportOptions = createDefaultReportOptions(unsummarizedDefinition);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!suppressActionsBar && /*#__PURE__*/_jsx(SRVDatasetTableActionsBar, {
      report: report,
      showViewInDatasets: true,
      selectedReport: SelectedReports.unsummarizedTable
    }), /*#__PURE__*/_jsx(PlatformReportResolver, {
      lazyReportResolve: false,
      report: report,
      initialReportOptions: initialReportOptions,
      useInlineLabels: false,
      trackingApplicationName: trackingApplicationName,
      trackingAssetType: trackingAssetType,
      trackingScreenName: trackingScreenName
    })]
  });
};